import { Icons as OutlineIcons } from "./outline-icons";
import { Icons as OutlineIconsV2 } from "./outline-icons-v2";

export { Icons as SolidIcons } from "./solid-icons";

export { Pictograms as OutlinePictograms } from "./outline-pictograms";

export const AllOutlineIcons = { ...OutlineIcons, ...OutlineIconsV2 } as const;

export { OutlineIcons, OutlineIconsV2 };

// New Iconoir-based icons (Icon<Name><Size><Variant> naming convention)
export * from "./iconoir";
